import styled from 'styled-components'

interface ITagLabelStyledProps {
  fullWidth?: boolean
}

export const TagLabelStyled = styled.span<ITagLabelStyledProps>`
  min-width: 0;

  ${(props) =>
    !props.fullWidth &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `};
`
